module.exports = __webpack_public_path__ + "static/media/iko.8eaf10e2.png";